import axios from "axios";
import { ApiPath } from "../../common/api-path/ApiPath";

const TIMEOUT_MS = 30000;

export const getAllDevices = async ({ storeCodes }) => {
    const storeCode = Array.isArray(storeCodes) ? storeCodes.join(',') : storeCodes;
    const response = await axios.get(`${ApiPath.baseUrl}/supply-chain/device`, {
        params: { storeCode },
        timeout: TIMEOUT_MS
    });
    return response.data;
};

export const getDevicePingData = async ({ storeCodes }) => {
    const storeCode = Array.isArray(storeCodes) ? storeCodes.join(',') : storeCodes;
    const response = await axios.get(`${ApiPath.baseUrl}/supply-chain/device/ping-data`, {
        params: { storeCode },
        timeout: TIMEOUT_MS
    });
    return response.data;
};

export const getDashboardData = async ({ storeCodes, from, to, latencyThresholdMs = 90, limit = 10 }) => {
    const storeCode = Array.isArray(storeCodes) ? storeCodes.join(',') : storeCodes;
    const response = await axios.get(`${ApiPath.baseUrl}/supply-chain/device/dashboard`, {
        params: { storeCode, from, to, latencyThresholdMs, limit },
        timeout: TIMEOUT_MS
    });
    return response.data;
};

export const deviceOnboardingRequest = async (deviceData) => {
    const response = await axios.post(`${ApiPath.baseUrl}/supply-chain/device`, deviceData, { timeout: TIMEOUT_MS, timeoutErrorMessage: "request timeout" });
    return response.data;
};

export const updateDeviceData = async (deviceData) => {
    const response = await axios.put(`${ApiPath.baseUrl}/supply-chain/device/${deviceData.deviceId}`, deviceData, { timeout: TIMEOUT_MS });
    return response.data;
};

export const toggleDeviceMonitoringStatus = async (deviceId) => {
    const response = await axios.post(`${ApiPath.baseUrl}/supply-chain/device/${deviceId}/status/toggle`, {}, { timeout: TIMEOUT_MS });
    return response.data;
};

export const deleteDevice = async (deviceId) => {
    const response = await axios.delete(`${ApiPath.baseUrl}/supply-chain/device/${deviceId}`, { timeout: TIMEOUT_MS });
    return response.data;
};
